var ezdia;
(function (ezdia) {
    function navHtml() {
        var e_1, _a;
        var _b = ezdia.config.pageParams, status = _b.status, roleLabel = _b.roleLabel, allRoles = _b.allRoles;
        var htmlContent = [];
        try {
            for (var allRoles_1 = __values(allRoles), allRoles_1_1 = allRoles_1.next(); !allRoles_1_1.done; allRoles_1_1 = allRoles_1.next()) {
                var role = allRoles_1_1.value;
                htmlContent.push("<li class=\"" + (roleLabel === role ? 'active' : '') + "\">\n        <a href=\"?roleLabel=" + role + "\">" + role + "</a>\n      </li>");
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (allRoles_1_1 && !allRoles_1_1.done && (_a = allRoles_1.return)) _a.call(allRoles_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return "<div class=\"clearfix ez-page-header-wrapper\">\n      <div class=\"col-md-12\">\n        <p></p>\n        <ul id=\"ez-js-role-nav\" id=\"roles-list\" class=\"ez-nav-pills ez-nav-pills-top\">\n          " + htmlContent.join('') + "\n        </ul>\n        <ul id=\"ez-js-status-nav\" class=\"ez-nav-pills secondary\">\n          <li class=\"" + (!status ? 'active' : '') + "\"><a href=\"javascript:void(0)\">All</a></li>\n          <li class=\"" + (status === 'starred' ? 'active' : '') + "\"><a href=\"javascript:void(0)\" data-status=starred>Favorites</a></li>\n        </ul>\n      </div>\n    </div>";
    }
    function noProjects() {
        return "<div class=\"ez-callout ez-callout-warning\">There are no projects to display.</div>";
    }
    function getSubTitle(card) {
        var name = card.name, projectType = card.projectType, wordCount = card.wordCount, pricing = card.pricing, role = card.role, roleLabel = card.roleLabel;
        var isDefault = name.match('default');
        var returnVal = "";
        if (isDefault && role) {
            returnVal = roleLabel;
        }
        else if (!isDefault) {
            if (projectType) {
                returnVal = projectType;
            }
            if (role) {
                returnVal = roleLabel;
            }
            if (wordCount) {
                returnVal = wordCount + " " + ezdia.util.pluralize(wordCount, 'word', 'words');
            }
            if (pricing) {
                returnVal = pricing;
            }
        }
        return returnVal;
    }
    function getTags(tags) {
        var e_2, _a;
        var htmlContent = [];
        if (tags && tags.length) {
            try {
                for (var tags_1 = __values(tags), tags_1_1 = tags_1.next(); !tags_1_1.done; tags_1_1 = tags_1.next()) {
                    var tag = tags_1_1.value;
                    htmlContent.push("<span class=\"label label-primary\">" + tag + "</span>");
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (tags_1_1 && !tags_1_1.done && (_a = tags_1.return)) _a.call(tags_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return htmlContent.join('');
    }
    function getCard(card) {
        var status = card.status, logo = card.logo, accountLabel = card.accountLabel, role = card.role, roleLabel = card.roleLabel, accountName = card.accountName, name = card.name, creativeBrief = card.creativeBrief, tags = card.tags;
        return "<div class=\"card-col\">\n      <div class=\"card\">\n        <ul class=\"pull-right icon-bar\">\n          <li>\n            <a href=\"javascript:void(0);\" data-action-favorite=\"" + name + "\">\n              <i class=\"fa ez-" + (status === 'starred' ? 'favorited' : 'favorite') + "\"></i>\n            </a> \n          </li>\n        </ul>\n        " + (logo
            ? "<div class=\"card-row image\" style=\"background-image: url(" + logo + ")\"></div>"
            : '') + "\n        <div class=\"card-row header\">\n          <div class=\"icon\"><i class=\"fa fa-folder\"></i></div>\n          <div class=\"text\">\n            <div class=\"title\">" + (accountLabel || '') + "</div>\n            <div class=\"subtitle\">" + getSubTitle(card) + "</div>\n          </div>\n        </div>\n        <div class=\"card-row action\">\n          <a href=\"MyOpenTask.htm?accountName=" + accountName + "&role=" + role + "&roleLabel=" + roleLabel + "&projInfoName=" + name + "\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-angle-right\"></i> Learn More</a>\n        </div>\n        " + getTags(tags) + "\n        " + (creativeBrief
            ? "<div class=\"card-row description\">" + creativeBrief + "</div>"
            : '') + "\n      </div>\n    </div>";
    }
    function cardsHtml(cards) {
        var e_3, _a;
        var htmlContent = [];
        try {
            for (var cards_1 = __values(cards), cards_1_1 = cards_1.next(); !cards_1_1.done; cards_1_1 = cards_1.next()) {
                var card = cards_1_1.value;
                var cardHtml = getCard(card);
                htmlContent.push(cardHtml);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (cards_1_1 && !cards_1_1.done && (_a = cards_1.return)) _a.call(cards_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return "<div id=\"ez-openProject-card-list\" class=\"row ez-card-list\">\n      " + htmlContent.join('') + "\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.openProjects = {
            navHtml: navHtml,
            cardsHtml: cardsHtml,
            noProjects: noProjects
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
